import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[boiMustMatch]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MustMatchDirective,
      multi: true
    }
  ]
})
export class MustMatchDirective implements Validator {
  @Input('boiMustMatch') public valueToMatch;

  validate(control: AbstractControl): ValidationErrors {
    if (control.value !== this.valueToMatch) {
      return { mustMatch: true };
    }

    return undefined;
  }
}
